
// eslint-disable-next-line import/prefer-default-export
export const ACTION_TYPE = {
  CONFIRM_ORDER_INFO: '/store/goods/Detail',
}
export const SELECT_INFO = process.env.NODE_ENV === 'production' ? 'PRO_STORE_SELECT_INFO' : 'DEV_STORE_SELECT_INFO'
export const GROUP_SELECT_INFO = process.env.NODE_ENV === 'production' ? 'PRO_GROUP_SELECT_INFO' : 'DEV_GROUP_SELECT_INFO'
export const TIME_LIMIT_INFO = process.env.NODE_ENV === 'production' ? 'PRO_TIME_LIMIT_INFO' : 'DEV_TIME_LIMIT_INFO'
export const ACTIVITY_INFO = process.env.NODE_ENV === 'production' ? 'PRO_ACTIVITY_INFO' : 'DEV_ACTIVITY_INFO'
